import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import {
  Button,
  Card,
  Form,
  InputGroup,
  Spinner,
  Alert,
} from "react-bootstrap";
import toast from "react-hot-toast";
import { AlertCircle } from "react-feather";

import listingService from "../../../../services/listingService";
import printService from "../../../../services/print.service";

const PrintLabelForm = ({ submitting, setSubmitting }) => {
  const [errorMessage, setErrorMessage] = useState();
  const [listingId, setListingId] = useState("");

  const getListingLabel = async () => {
    if (!listingId) {
      toast.error("Please enter a Listing ID.");
      return;
    }

    // Check if the value is "W". ¯\_(ツ)_/¯
    if (listingId.toUpperCase() === "W") {
      toast.error("Please re-scan the Listing ID or enter it manually.");
      setListingId("");
      return;
    }

    if (isNaN(listingId)) {
      toast.error("Listing ID contains characters.");
      setListingId("");
      setErrorMessage(
        "Incorrect Listing ID. The listing ID should contain only digits. Auction Labels and Bin Store Labels are not accepted. Only Pending FNSKU Labels with digit listing IDs are accepted."
      );
      return;
    }

    setSubmitting(true);
    setErrorMessage();

    const response = await listingService.getListingLabelData(listingId);

    if (response.success) {
      const { listingLabelData } = response;

      await printService.printListingLabel({
        fnsku: listingLabelData.fnsku,
        sku: listingLabelData.sku,
        amazonConditionLabel: listingLabelData.amazonConditionLabel,
        inspectConditionCode: listingLabelData.inspectConditionCode,
        title: listingLabelData.title,
        listingAccountId: listingLabelData.listingAccountId,
        listingId: listingLabelData.listingId,
        quantity: listingLabelData.quantity,
      });
    } else {
      setErrorMessage(response?.message);
      toast.error(response?.message);
    }

    setListingId("");
    setSubmitting(false);
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-start">
        <FontAwesomeIcon icon={faPrint} size="3x" className="me-3" />
        <div>
          <Card.Title>Print PENDING_FNSKU Listing Label</Card.Title>
          <Card.Subtitle>
            Scan or enter an item's Listing ID to get a listing label for newly
            created listings.
          </Card.Subtitle>
        </div>
      </Card.Header>
      <Card.Body>
        {errorMessage && (
          <Alert variant="danger" className="flex-fill alert-blink">
            <div className="alert-icon">
              <AlertCircle
                className="position-relative top-50 start-50 translate-middle"
                size={20}
              />
            </div>
            <div className="alert-message font-weight-bold">{errorMessage}</div>
          </Alert>
        )}
        <Form.Label className="mb-0">Listing ID</Form.Label>
        <InputGroup>
          <Form.Control
            required
            autoFocus
            size="lg"
            placeholder="Scan or Enter FNSKU..."
            value={listingId}
            onChange={(e) => setListingId(e.target.value)}
            onFocus={(e) => {
              e.target.select();
            }}
            onKeyUp={(e) => {
              if (e.key === "Enter") {
                getListingLabel();
              }
            }}
            disabled={submitting}
          />

          <Button
            variant="primary"
            onClick={getListingLabel}
            disabled={submitting}
          >
            {submitting ? (
              <span>
                <Spinner
                  className="me-2"
                  animation="border"
                  size="sm"
                  role="status"
                />
                Submitting...
              </span>
            ) : (
              "Submit"
            )}
          </Button>
        </InputGroup>
      </Card.Body>
    </Card>
  );
};

export default PrintLabelForm;
